export type SimulateClickPayload = {
  sessionId: number;
  divisionLabel: string;
  sessionLabel: string;
  panelHost: HTMLElement;
};

export type SimulateClickHandler = (payload: SimulateClickPayload) => void | Promise<void>;

let documentBound = false;
let activeHandler: SimulateClickHandler | null = null;

export function clearChampionshipSimulateBindings(): void {
  activeHandler = null;
  documentBound = false;
}

function handleSimulateClick(e: Event): void {
  const target = e.target;
  if (!(target instanceof Element)) return;
  const btn = target.closest<HTMLButtonElement>('button[data-championship-simulate]');
  if (!btn) return;

  const panelHost = btn.closest<HTMLElement>(
    '#seasons-championship-host, [data-championship-panel-host]'
  );
  if (!panelHost) return;

  const sessionId = Number(btn.dataset.sessionId);
  if (!Number.isFinite(sessionId)) return;

  const handler = activeHandler;
  if (!handler) return;

  void handler({
    sessionId,
    divisionLabel: btn.dataset.divisionLabel ?? 'Division',
    sessionLabel: btn.dataset.sessionLabel ?? 'cette manche',
    panelHost,
  });
}

/** Listener document unique — survit aux re-mount et aux innerHTML. */
export function bindChampionshipSimulateDelegation(
  _panelHost: HTMLElement,
  handler: SimulateClickHandler
): void {
  activeHandler = handler;
  if (documentBound) return;
  documentBound = true;
  document.addEventListener('click', handleSimulateClick);
}
